import { Directive, HostBinding, HostListener, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

// animate('300ms ease-out', style({ left: '0%'}))
export const DetailsExpandAnimation = trigger('detailExpand', [
  transition(':enter', [
    style({ opacity: 0, 'margin-top': '-260px' }), animate('700ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 1, 'margin-top': 0 }))]
  ),
  transition(':leave',
    [style({ opacity: 1, 'margin-top': '0' }),  animate('700ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 0, 'margin-top': '-260px' }))]
  )
]);

@Directive({
  selector: '[detailsTemplate]',
  exportAs: 'detailsTemplate'
})
export class DetailsExpandDirective implements OnChanges {

  private tRef: TemplateRef<any>;

  @Input()
  isOpened: boolean;

  private initialized: boolean;

  @HostBinding('class.expanded')
  get expanded(): boolean {
    return this.isOpened;
  }

  @Input('detailsTemplate')
  set template(value: TemplateRef<any>) {
    if (value !== this.tRef) {
      this.tRef = value;
    }
  }

  constructor(public vcRef: ViewContainerRef) {
  }

  ngOnChanges(): void {
    if (!this.initialized) {
      this.initialized = true;
      return;
    }
    this.toggle();
  }

  @HostListener('click', ['$event'])
  onClick(event): void {
    this.toggle();
  }

  toggle(): void {
    if (this.isOpened) {
      this.render();
    } else {
      this.vcRef.clear();
    }
  }

  private render(): void {
    this.vcRef.clear();
    if (this.tRef && this.isOpened) {
      this.vcRef.createEmbeddedView(this.tRef);
    }
  }
}
